import SectionMessage, { SectionMessageAction } from '@atlaskit/section-message';
import React from 'react';

import ExternalLinkAction from '@/components/primitive/external-link';
import { DAC_SLO_HIGH_CARDINALITY_LINK } from '@/constants';
import { spaceTopCozy } from '@/styles';

const HighCardinalityWarning = () => (
  <div css={[spaceTopCozy]}>
    <SectionMessage
      appearance="warning"
      actions={[
        <SectionMessageAction key="high-cardinality-message" href="#">
          <ExternalLinkAction text="Find out more" href={DAC_SLO_HIGH_CARDINALITY_LINK} />
        </SectionMessageAction>,
      ]}
    >
      <p>
        The SignalFlow queries for this SLO use high cardinality metrics, which can increase false
        positives and/or negatives in alerts.
      </p>
    </SectionMessage>
  </div>
);
export default HighCardinalityWarning;
